import { render, staticRenderFns } from "./finance-ip.vue?vue&type=template&id=0b5e4896&scoped=true&"
import script from "./finance-ip.vue?vue&type=script&lang=js&"
export * from "./finance-ip.vue?vue&type=script&lang=js&"
import style0 from "./finance-ip.vue?vue&type=style&index=0&id=0b5e4896&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e4896",
  null
  
)

export default component.exports